module.exports = __webpack_public_path__ + "static/img/ARAD2S_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD2S_1.png
// module id = YHVD
// module chunks = 0